// extracted by mini-css-extract-plugin
module.exports = {"pricesTable":"marketplace_pricesTable__K5NZP","conditionalText":"marketplace_conditionalText__OKD1U","pageWrap":"marketplace_pageWrap__Ha9p6"};